export const API_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const OAUTH_URL = process.env.REACT_APP_OAUTH_URL